export default __webpack_public_path__ + "static/media/rolo.7e5b8fd6.svg";